// removed by extract-text-webpack-plugin
module.exports = {"isNetPrice":"styles__isNetPrice__109eca10","price":"styles__price__109eca10","net":"styles__net__109eca10","percentOff":"styles__percentOff__109eca10","retail":"styles__retail__109eca10","retailPrice":"styles__retailPrice__109eca10","salePrice":"styles__salePrice__109eca10"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/ReducedPrice/styles.scss
// module id = 1080
// module chunks = 4 14